import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {BoxTypes} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 31;

export const migration_30_31:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            designState.surface.onApplicationLoadProp = {
                id: IdUtil.newGUID(),
                name: 'onApplicationLoad',
                boxId: null,
                bindingId: null,
                isEnabled: false
            };
        }

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {id, boxType, componentDesc} = boxSnapshot;

                        if( boxType === BoxTypes.Viewport )
                        {
                            checkAndAddEventProp(['onKeyDown', 'onKeyPress', 'onKeyUp'],componentDesc, id);
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function checkAndAddEventProp(eventNames:string[], componentDesc:any, boxId:any)
{
    eventNames.forEach(eventName => {
        let eventPropSnapshot:any = Object.values(componentDesc._eventProps).find(
            (eventPropSnapshot:any) => eventPropSnapshot.name === eventName
        );

        if( !eventPropSnapshot )
        {
            eventPropSnapshot = {
                id: IdUtil.newGUID(),
                name: eventName,
                boxId,
                isEnabled: false,
                bindingId: null
            };

            const eventProps:any = componentDesc._eventProps;

            componentDesc._eventProps = {
                [eventPropSnapshot.id]: eventPropSnapshot,
                ...eventProps
            };
        }
    });
}
